function Footer() {
  return (
    <footer
      className="text-white text-center py-3 "
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      <div className="container">
      <p className="mb-0">
        &copy; {new Date().getFullYear()} Department of Social Services, Sri Lanka. All Rights Reserved.
      </p>
      </div>
    </footer>
  );
}

export default Footer;
